import { RnLinkToSomewhere, RnPen } from "@remi/icons/next";
import { RemiButton } from "@remi/next-ui";
import { can } from "@remi/permissions";

import { useSetContactView } from "~/contexts/ContactsContext";
import { useUserProfile } from "~/contexts/UserProfileContext";
import { cn } from "~/lib/utils";

type ContactDrawerButtonProps = {
  personId: string;
  className?: string;
};

export const ContactDrawerButton = ({ personId, className }: ContactDrawerButtonProps) => {
  const { setContactViewingId, setIsEditing } = useSetContactView();
  const { user } = useUserProfile();

  if (!can.person.viewDetails(user)) {
    return null;
  }

  const openDrawer = (editing: boolean) => {
    setContactViewingId(personId);
    setIsEditing(editing);
  };

  return (
    <div
      className={cn("flex items-center gap-0.5 transition-all group-hover/contact:opacity-100 md:opacity-0", className)}
    >
      <RemiButton
        icon={<RnLinkToSomewhere />}
        muted
        onClick={() => openDrawer(false)}
        aria-label="View contact details"
      />
      <RemiButton icon={<RnPen />} muted onClick={() => openDrawer(true)} aria-label="Edit contact" />
    </div>
  );
};
